// import React, { useEffect, useState } from "react";
// import axios from "../../api/axiosInstance";
// import toast from "react-hot-toast";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/navigation";
// import { Navigation } from "swiper/modules";
// import dayjs from "dayjs";
// import { useNavigate } from "react-router-dom";
// import bg from "../../assets/membership.jpg";
// import mainbg from "../../assets/cardbg.jpeg";
// // Skeleton card
// const SkeletonCard = () => (
//   <div className="flex flex-col items-center bg-gray-100 animate-pulse p-4 rounded-xl shadow w-full h-64 justify-center">
//     <div className="w-28 h-28 md:w-32 md:h-32 bg-gray-300 rounded-full mb-3"></div>
//     <div className="h-4 bg-gray-300 rounded w-24 mb-2"></div>
//     <div className="h-3 bg-gray-300 rounded w-16"></div>
//   </div>
// );

// const Matcheslast30Days = () => {
//   const [matches, setMatches] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//   const calculateAge = (dob) => dayjs().diff(dayjs(dob), "year");

//   useEffect(() => {
//     const fetchMatches = async () => {
//       try {
//         setLoading(true);
//         const res = await axios.get("/api/matches/", {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//           },
//         });

//         // Filter profiles created in the last 30 days
//         const recentMatches = res.data.filter(
//           (match) => dayjs().diff(dayjs(match.created_at), "day") <= 30
//         );

//         setMatches(recentMatches);
//         setLoading(false);
//       } catch (error) {
//         toast.error("Failed to load matches");
//         setLoading(false);
//       }
//     };

//     fetchMatches();
//   }, []);

//   return (
//     <div
//       className="w-full p-6 bg-white rounded shadow"

//     >
//       <h2 className="text-2xl font-bold mb-2">
//         New Matches ({matches.length})
//       </h2>
//       <p className="text-gray-500 mb-4">
//         Members who have joined in the last 30 days
//       </p>

//       {loading ? (
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
//           {[...Array(3)].map((_, idx) => (
//             <SkeletonCard key={idx} />
//           ))}
//         </div>
//       ) : matches.length > 0 ? (
//         <Swiper
//           slidesPerView={1}
//           spaceBetween={15}
//           navigation={true}
//           modules={[Navigation]}
//           breakpoints={{
//             640: { slidesPerView: 1, spaceBetween: 15 }, // mobile
//             768: { slidesPerView: 2, spaceBetween: 20 }, // tablet
//             1024: { slidesPerView: 3, spaceBetween: 25 }, // desktop
//           }}
//           className="mySwiper"
//         >
//           {matches.map((match) => (
//             <SwiperSlide key={match.id}>
//               <div
//                 className="flex flex-col items-center bg-gray-50 p-4 rounded-xl shadow hover:shadow-lg transition cursor-pointer"
//                 style={{
//                   backgroundImage: `url(${bg})`,
//                   backgroundSize: "cover",
//                   backgroundPosition: "center",
//                 }}
//                 onClick={() => navigate(`/profile/${match.user.id}`)}
//               >
//                 <img
//                   src={
//                     match.photo || require("../../assets/default_image.webp")
//                   }
//                   alt={`${match.user.first_name}`}
//                   className="w-28 h-28 md:w-32 md:h-32 object-cover rounded-full border-4 border-pink-200 mb-3"
//                 />
//                 <p className="font-semibold text-lg text-gray-800">
//                   {`${match.user.first_name} ${match.user.last_name}`}
//                 </p>
//                 <p className="text-sm text-gray-600">
//                   {calculateAge(match.dob)} Yrs • {match.height_feet}'
//                   {match.height_inches}" height • {match.work_location_city}
//                 </p>
//               </div>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       ) : (
//         <p className="text-gray-500 text-center">No matches found.</p>
//       )}
//     </div>
//   );
// };

// export default Matcheslast30Days;

// src/components/Matcheslast30Days.jsx

import React, { useEffect, useState } from "react";
import axios from "../../api/axiosInstance";
import toast from "react-hot-toast";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

/* ─── CSS ─────────────────────────────────────────────────────────────────── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;1,600&family=Inter:wght@400;500;600&display=swap');

.jb30 {
  width: 100%;
  background: linear-gradient(160deg, #1A0505 0%, #3D0A0A 55%, #5A1010 100%);
  border: 1px solid rgba(201,150,42,0.25);
  border-radius: 20px;
  padding: clamp(20px, 3.5vw, 36px);
  font-family: 'Inter', sans-serif;
  position: relative;
  overflow: hidden;
}

/* gold top bar */
.jb30::before {
  content: '';
  position: absolute; top: 0; left: 0; right: 0; height: 3px;
  background: linear-gradient(90deg, transparent, #C9962A 30%, #E8C46A 50%, #C9962A 70%, transparent);
  z-index: 2;
}

/* dot-grid watermark */
.jb30-dust {
  position: absolute; inset: 0; pointer-events: none;
  background-image: radial-gradient(circle, rgba(201,150,42,0.08) 1px, transparent 1px);
  background-size: 36px 36px;
}

/* ── Header ── */
.jb30-header {
  position: relative; z-index: 1;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: clamp(16px, 2.5vw, 24px);
  flex-wrap: wrap;
}
.jb30-badge {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 3px 10px;
  background: rgba(201,150,42,0.12);
  border: 1px solid rgba(201,150,42,0.35);
  border-radius: 20px;
  font-size: 10px; font-weight: 600;
  letter-spacing: 1.5px; text-transform: uppercase;
  color: #C9962A;
  margin-bottom: 7px;
}
.jb30-badge-dot {
  width: 6px; height: 6px; border-radius: 50%;
  background: #C9962A;
  animation: jb30Blink 1.8s ease-in-out infinite;
}
@keyframes jb30Blink { 0%,100%{opacity:1} 50%{opacity:.3} }

.jb30-title {
  font-family: 'Playfair Display', serif;
  font-size: clamp(17px, 2.2vw, 23px);
  font-weight: 700; color: #FDF6EC;
  margin-bottom: 4px; line-height: 1.2;
}
.jb30-title em { font-style: italic; color: #E8C46A; }
.jb30-count { color: #C9962A; font-weight: 600; }
.jb30-subtitle {
  font-size: clamp(11px, 1.1vw, 13px);
  color: rgba(253,246,236,0.58);
}

/* ── Skeleton ── */
.jb30-skel {
  position: relative; z-index: 1;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 14px;
}
.jb30-sk-card {
  background: rgba(201,150,42,0.07);
  border: 1px solid rgba(201,150,42,0.14);
  border-radius: 14px;
  padding: 22px 14px;
  display: flex; flex-direction: column; align-items: center; gap: 11px;
  animation: jb30Pulse 1.6s ease-in-out infinite;
}
@keyframes jb30Pulse { 0%,100%{opacity:1} 50%{opacity:.4} }
.jb30-sk-av  { width:80px; height:80px; border-radius:50%; background:rgba(201,150,42,.14); }
.jb30-sk-ln  { height:11px; border-radius:5px; background:rgba(201,150,42,.11); }

/* ── Swiper overrides ── */
.jb30-swiper {
  position: relative; z-index: 1;
  padding: 4px 32px 36px !important;
}

/* Nav arrows */
.jb30-swiper .swiper-button-prev,
.jb30-swiper .swiper-button-next {
  width: 34px !important; height: 34px !important;
  border-radius: 50%;
  background: rgba(201,150,42,0.18) !important;
  border: 1.5px solid rgba(201,150,42,0.4);
  color: #C9962A !important;
  transition: background 0.18s;
  top: calc(50% - 18px) !important;
}
.jb30-swiper .swiper-button-prev:hover,
.jb30-swiper .swiper-button-next:hover {
  background: rgba(201,150,42,0.32) !important;
}
.jb30-swiper .swiper-button-prev::after,
.jb30-swiper .swiper-button-next::after {
  font-size: 13px !important; font-weight: 700;
}
.jb30-swiper .swiper-button-disabled {
  opacity: 0.25 !important;
}

/* ── Match card ── */
.jb30-card {
  background: linear-gradient(160deg, #3D0A0A 0%, #5A1010 100%);
  border: 1px solid rgba(201,150,42,0.2);
  border-radius: 16px;
  padding: clamp(16px, 2.5vw, 22px) clamp(12px, 2vw, 16px);
  display: flex; flex-direction: column; align-items: center; text-align: center;
  cursor: pointer; position: relative; overflow: hidden;
  transition: border-color 0.2s, transform 0.2s, box-shadow 0.2s;
}
.jb30-card::after {
  content: '';
  position: absolute; top: 0; left: 0; right: 0; height: 2px;
  background: linear-gradient(90deg, transparent, #C9962A, transparent);
}
.jb30-card:hover {
  border-color: rgba(201,150,42,0.5);
  transform: translateY(-3px);
  box-shadow: 0 12px 32px rgba(0,0,0,0.4);
}

/* "New" ribbon */
.jb30-ribbon {
  position: absolute; top: 10px; right: -1px;
  background: linear-gradient(90deg, #C9962A, #A87820);
  color: #2C1A0E; font-size: 9px; font-weight: 700;
  letter-spacing: 1px; text-transform: uppercase;
  padding: 3px 10px 3px 8px;
  border-radius: 4px 0 0 4px;
}

/* avatar */
.jb30-av-wrap {
  position: relative;
  width: clamp(78px, 10vw, 96px);
  height: clamp(78px, 10vw, 96px);
  margin-bottom: 13px;
}
.jb30-av {
  width: 100%; height: 100%;
  object-fit: cover; border-radius: 50%;
  border: 3px solid #C9962A;
  box-shadow: 0 0 0 4px rgba(201,150,42,0.15);
}
.jb30-av-om {
  position: absolute; bottom: 0; right: 0;
  width: 22px; height: 22px; border-radius: 50%;
  background: #C9962A;
  display: flex; align-items: center; justify-content: center;
  font-size: 10px; color: #2C1A0E; font-family: serif;
  border: 2px solid #3D0A0A;
}

.jb30-name {
  font-family: 'Playfair Display', serif;
  font-size: clamp(13.5px, 1.5vw, 15.5px);
  font-weight: 700; color: #FDF6EC;
  margin-bottom: 4px;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%;
}
.jb30-details {
  font-size: clamp(10.5px, 1.1vw, 12px);
  color: rgba(253,246,236,0.60);
  line-height: 1.55; margin-bottom: 13px;
}
.jb30-card-btn {
  padding: 6px 18px;
  background: transparent;
  border: 1.5px solid rgba(201,150,42,0.5);
  border-radius: 18px;
  color: #E8C46A; font-size: 11.5px; font-weight: 600;
  cursor: pointer; font-family: 'Inter', sans-serif;
  transition: background 0.18s, border-color 0.18s;
}
.jb30-card:hover .jb30-card-btn {
  background: rgba(201,150,42,0.14); border-color: #C9962A;
}

/* ── Empty ── */
.jb30-empty {
  position: relative; z-index: 1;
  text-align: center; padding: clamp(28px, 4vw, 48px) 16px;
}
.jb30-empty-om {
  font-size: 42px; color: #C9962A; opacity: 0.2;
  font-family: serif; margin-bottom: 10px;
}
.jb30-empty-txt {
  font-family: 'Playfair Display', serif;
  font-size: clamp(13px, 1.5vw, 16px);
  color: rgba(253,246,236,0.45);
}

/* ── Responsive ── */
@media (max-width: 560px) {
  .jb30-header { flex-direction: column; }
  .jb30-swiper { padding: 4px 28px 32px !important; }
}
@media (max-width: 360px) {
  .jb30 { border-radius: 0; }
  .jb30-swiper { padding: 4px 24px 28px !important; }
}
`;

/* ─── Skeleton ────────────────────────────────────────────────────────────── */
const SkeletonCard = () => (
  <div className="jb30-sk-card">
    <div className="jb30-sk-av" />
    <div className="jb30-sk-ln" style={{ width: "68%" }} />
    <div className="jb30-sk-ln" style={{ width: "50%" }} />
    <div className="jb30-sk-ln" style={{ width: "36%", height: 8 }} />
  </div>
);

/* ─── Component ───────────────────────────────────────────────────────────── */
const Matcheslast30Days = () => {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const calculateAge = (dob) => dayjs().diff(dayjs(dob), "year");

  /* inject CSS */
  useEffect(() => {
    const id = "jb30-styles";
    if (!document.getElementById(id)) {
      const el = document.createElement("style");
      el.id = id;
      el.textContent = CSS;
      document.head.appendChild(el);
    }
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, []);

  useEffect(() => {
    const fetchMatches = async () => {
      try {
        setLoading(true);
        const res = await axios.get("/api/matches/", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        });
        const recentMatches = res.data.filter(
          (m) => dayjs().diff(dayjs(m.created_at), "day") <= 30,
        );
        setMatches(recentMatches);
      } catch {
        toast.error("Failed to load new matches");
      } finally {
        setLoading(false);
      }
    };
    fetchMatches();
  }, []);

  return (
    <div className="jb30">
      <div className="jb30-dust" aria-hidden="true" />

      {/* ── Header ── */}
      <div className="jb30-header">
        <div>
          <div className="jb30-badge">
            <span className="jb30-badge-dot" aria-hidden="true" />
            Joined in the last 30 days
          </div>
          <h2 className="jb30-title">
            New <em>Sacred</em> Matches{" "}
            <span className="jb30-count">({matches.length})</span>
          </h2>
          <p className="jb30-subtitle">
            Freshly joined Jain souls seeking their Dharmic companion
          </p>
        </div>
      </div>

      {/* ── Loading ── */}
      {loading ? (
        <div className="jb30-skel">
          {[...Array(3)].map((_, i) => (
            <SkeletonCard key={i} />
          ))}
        </div>
      ) : matches.length > 0 ? (
        /* ── Swiper ── */
        <Swiper
          className="jb30-swiper"
          slidesPerView={1}
          spaceBetween={16}
          navigation={true}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          modules={[Navigation, Autoplay]}
          breakpoints={{
            640: { slidesPerView: 1, spaceBetween: 14 },
            768: { slidesPerView: 2, spaceBetween: 16 },
            1024: { slidesPerView: 3, spaceBetween: 18 },
          }}
        >
          {matches.map((match) => (
            <SwiperSlide key={match.id}>
              <div
                className="jb30-card"
                onClick={() => navigate(`/profile/${match.user.id}`)}
                role="button"
                tabIndex={0}
                aria-label={`View profile of ${match.user.first_name}`}
                onKeyDown={(e) =>
                  e.key === "Enter" && navigate(`/profile/${match.user.id}`)
                }
              >
                {/* "New" ribbon */}
                <div className="jb30-ribbon" aria-label="New member">
                  NEW
                </div>

                {/* Avatar */}
                <div className="jb30-av-wrap">
                  <img
                    src={
                      match.photo || require("../../assets/default_image.webp")
                    }
                    alt={match.user.first_name}
                    className="jb30-av"
                  />
                  <div className="jb30-av-om" aria-hidden="true">
                    ꣽ
                  </div>
                </div>

                <p className="jb30-name">
                  {match.user.first_name} {match.user.last_name}
                </p>
                <p className="jb30-details">
                  {calculateAge(match.dob)} Yrs
                  {match.height_feet
                    ? ` • ${match.height_feet}'${match.height_inches}"`
                    : ""}
                  {match.work_location_city
                    ? ` • ${match.work_location_city}`
                    : ""}
                </p>

                <button
                  className="jb30-card-btn"
                  tabIndex={-1}
                  aria-hidden="true"
                >
                  🪷 View Profile
                </button>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        /* ── Empty ── */
        <div className="jb30-empty">
          <div className="jb30-empty-om" aria-hidden="true">
            ꣽ
          </div>
          <p className="jb30-empty-txt">
            No new sacred matches in the last 30 days — check back soon.
          </p>
        </div>
      )}
    </div>
  );
};

export default Matcheslast30Days;
